export const config = {
  headers: {
    "Authorization": '',
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};
export const RequiredMessage = "This field is required";
export const InvalidMessage = "Invalid valid value";
export const PasswordMessage = "Password must 6 or more than characters";